import { JDSTabBarProps } from './generated/interface';
import { useRootRef } from '../../hooks/useRootRef';

export const withLogic =
  (Component: React.ComponentType<JDSTabBarProps>): React.FC<JDSTabBarProps> =>
  (props: JDSTabBarProps) => {
    const { rootRef, element } = useRootRef();
    const tabContainers = Array.from(
      element?.querySelectorAll('div.j-JDSTabItem-outer-container') || []
    );
    const active = tabContainers[props.activeTab || 0];
    return (
      <Component
        {...{
          ...props,
          rootRef,
          _left: active?.offsetLeft,
          _width: active?.offsetWidth
        }}
      />
    );
  };
